import { MessageCircle } from "lucide-react";
import { CONTACT, TID } from "@/data/site";

const FloatingWhatsapp = () => {
  const message = encodeURIComponent(
    "Hello! I'd like to book a taxi in Athens."
  );
  const href = `https://wa.me/${CONTACT.phoneRaw}?text=${message}`;

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat on WhatsApp"
      data-testid={TID.floatingWhatsapp}
      className="fixed bottom-5 right-5 z-50 inline-flex items-center gap-2 rounded-full bg-[#1f9d52] hover:bg-[#25D366] text-white shadow-md shadow-black/20 px-4 py-3 transition-all duration-300 hover:scale-105"
    >
      <MessageCircle className="h-5 w-5" strokeWidth={2.2} />
      <span className="hidden sm:inline text-sm font-semibold">WhatsApp</span>
    </a>
  );
};

export default FloatingWhatsapp;
